<div class="rp-container">
    <div class="rp-view">
        <h2 class="rp-label">Password Canged!</h2>
        <p class="rp-success-text">Your password has been reset successfully.
        </p>
        <p class="rp-info">Please click the below button to signin:</p>
        <div class="rp-btn">
            <ccdl-button (onClick)="signInViewClick()" [btnLabel]="'SIGN IN'" [btnType]="'primary'"></ccdl-button>
        </div>
    </div>
</div>